import apiBase from "./api-base";

export default class Category extends apiBase {
    constructor(store) {
        const path = "v1/Category";
        super(store, path);
    }

    get (filter ) {
        return this._request({
            action: "Get",
            method: "GET",
            params: filter,
            
        });
    }

    list (filter, showProgress) {
        return this._request({
            action: "Get",
            method: "GET",
            params: filter,
            showProgress,
        });
    }

    getCategoryWithFoodDrink (filter, showProgress) {
        return this._request({
            action: "GetCategoryWithFoodDrink",
            method: "GET",
            params: filter,
            showProgress,
        });
    }

    create(model, showProgress) {
        return this._request({
            action: "Create",
            method: "POST",
            body: model,
            showProgress,
        });
    }

    update(model, id,  showProgress) {
        return this._request({
            action: `Update/${id}`,
            method: "PUT",
            body: model,
            showProgress,
        });
    }

    UpdateMenuboardTVByCategory(model, id) {
        return this._request({
            action: `UpdateMenuboardTVByCategory/${id}`,
            method: "PUT",
            body: model,
        });
    }
    updateAvailable(model, id,  showProgress) {
        return this._request({
            action: `UpdateAvailble/${id}`,
            method: "PUT",
            body: model,
            showProgress,
        });
    }

    delete(model, id, showProgress) {
        return this._request({
            action: `Delete/${id}`,
            method: "DELETE",
            body: model,
            showProgress,
        });
    }
}
